import Box from "../Box";
import {
	LeaderboardPodiumCard,
	PODIUM_CARD_HEIGHTS,
} from "./LeaderboardPodiumCard";
import { getPodiumItems } from "./helpers";
import type { LeaderboardItem } from "./types";

export const PODIUM_CHART_MAX_WIDTH = 446;
/** The row is exactly as tall as the tallest card, so the steps bottom-align. */
export const PODIUM_CHART_HEIGHT = PODIUM_CARD_HEIGHTS[1];

type Props = {
	items: LeaderboardItem[];
	currentUsername?: string;
};

export const LeaderboardPodiumChart = ({ items, currentUsername }: Props) => {
	const podiumItems = getPodiumItems(items);

	if (podiumItems.length === 0) {
		return null;
	}

	return (
		<Box
			flexDirection="row"
			alignItems="flex-end"
			minHeight={PODIUM_CHART_HEIGHT}
			width="100%"
			style={{
				maxWidth: PODIUM_CHART_MAX_WIDTH,
				marginHorizontal: "auto",
			}}
		>
			{podiumItems.map((item) => (
				<Box key={item.rank} flex={1}>
					<LeaderboardPodiumCard
						{...item}
						isCurrentUser={
							currentUsername !== undefined && item.username === currentUsername
						}
					/>
				</Box>
			))}
		</Box>
	);
};
